import type { IBatchStore } from './batch-store-types';
import { DeviceStatus } from '../../constants/DeviceStatus';

export const deviceStatusMixin = {

  /**
   * Get default device status object
   *
   * @param device
   * @returns default status object
   */
  getDeviceStatusDefault(this: IBatchStore, device: any = {}): any {
    return {
      id: device.id,
      type: (device.deviceTypeName || '').toUpperCase(),
      unit: '',
      target: 0,
      finishTarget: 0,
      totalFinalTarget: 0,
      weight: 0,
      isSubstituted: false,
      substitutionWeight: 0,
      targetIsNet: false,
      startWeight: 0,
      prevWeight: 0,
      weightUpdated: 0,
      manualStartWeight: 0,
      manualFeedStarted: false,
      isManual: false,
      initialPumpValue: 0,
      holdWeight: 0,
      finishWeight: 0,
      prevStatus: DeviceStatus.IDLE,
      status: DeviceStatus.IDLE,
      flowRate: 0,
      currentFlowRate: 0,
      mCode: null,
      error: false,
      currentDrop: 0,
      allDrops: 0,
      uid: null,
      tId: '',
      truckCode: '',
      materialCode: '',
      overridden: false,
      errorsOverridden: [],
      firstGateInitialOpenSent: false,
      secondGateInitialOpenSent: false,
      restart: false,
      active: false,
    };
  },

  /**
   * Get device status by id
   *
   * @param id
   * @returns device status object
   */
  getDeviceStatus(this: IBatchStore, id: any): any {
    const d = this.deviceStatus.get(id);

    if (d) {
      return { ...d, id };
    }

    return this.getDeviceStatusDefault({
      id,
      ...this.devicesStore.getDeviceById(id),
    });
  },

  /**
   * Clear all non-active device statuses
   */
  clearDeviceStatus(this: IBatchStore): void {
    let d = new Map();

    this.deviceStatus.forEach((v: any) => {
      if (v.active) {
        d.set(Number(v.id), v);
      }
    });

    this.deviceStatus = d;
  },

  /**
   * Clear first device error
   */
  clearDeviceError(this: IBatchStore, deviceId?: any): any {
    let id = deviceId;

    if (id) {
      this.deviceStatus.set(id, { ...this.getDeviceStatus(id), error: false, overridden: true });
      return id;
    }

    this.deviceStatus.forEach((v: any) => {
      if (v.error && v.id && !id) {
        this.deviceStatus.set(v.id, { ...v, error: false, overridden: true });
        id = v.id;
      }
    });

    return id;
  },

};
